import { IPostbackSendFormLang } from '../../../types/lang'

export const postbackSendFormLang: IPostbackSendFormLang = {
	postback_send_form: {
		field_sub_id_label: 'Sub Id_ua',
		field_sub_id_placeholder: 'Insert or enter options..._ua',
		field_postback_status_label: 'Postback Status_ua',
		field_postback_status_placeholder: 'Postback Status_ua',
		field_postback_currency_label: 'Currency_ua',
		field_postback_currency_placeholder: 'Currency_ua',
		field_postback_amount_label: 'Amount_ua',
		field_postback_amount_placeholder: 'Type number_ua',
		msg_postback_send_success: 'Postback sent successfully!_ua',
		msg_postback_send_error: 'Postback send error!_ua',
		btn_send: 'Send_ua'
	}
}